import { Card, Col, Row } from "react-bootstrap";
import CircleCountDown from "./CircleCountDown";
import { useTranslation } from "react-i18next";

export default function SalaEspera({ items, onCompleteTimeStart }) {
  const { t } = useTranslation();
  const { cita } = items;
  console.log(items);
  return (
    <Row>
      <Col xs="12" md={{ span: 10, offset: 1 }}>
        <Card className="my-5 shadow-sm">
          <Card.Body className="text-center">
            <h5 className="colorLink text-center mb-4">Sala de espera</h5>
            <CircleCountDown
              items={items}
              onCompleteTimeStart={onCompleteTimeStart}
            />
            <div className="mt-3 mb-5">
              <h6 className="colorLabel">{cita.scheduleDTO.name_doctor}</h6>
              <span className="d-block colorLabel fw-medium">
                Nombre del paciente
              </span>
              <span className="d-block colorLabel fw-medium">{`${cita.patientDTO.name} ${cita.patientDTO.middleName} ${cita.patientDTO.lastName} ${cita.patientDTO.seccondSurname}`}</span>
              {/* <span className="d-block colorLabel fw-medium">Email</span>
                            <span className="d-block colorLabel fw-medium">{cita.patientDTO.email}</span>
                            <span className="d-block colorLabel fw-medium">Teléfono</span>
                            <span className="d-block colorLabel fw-medium">{cita.patientDTO.phone}</span> */}
            </div>
            <div className="mt-5">
              {/* {
                            cita?.patientDTO?.company?.id === 1 && 
                                <span className="colorLabel">{t('problemas_video_call')}</span>
                        }*/}
              {cita?.patientDTO?.company?.id === 2 && (
                <span className="colorLabel">
                  {t("problemas_video_call_colombia")}
                </span>
              )}
              {cita.patientDTO.account.helpCenter && (
                <div className="mt-4">
                  <span className="colorLabel fw-medium">
                    {cita.patientDTO.account.helpCenter}
                  </span>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
